export const pageSlugUrlKey = 'pageSlug';
export const drilldownLabelUrlKey = 'drillDownLabel';
